<template>
  <div class="page">
    <div class="cell-title">请输入您的车牌号</div>
      <van-form @submit="onSubmit" :submit-on-enter="false" class="plate-form">
        <van-field v-model="plateNumber" size="large" name="plateNumber" label="车牌号:" label-width="3.5em" placeholder="请输入车牌号" :rules="[{pattern: plateNumberPattern, message: '车牌不正确'}]">
          <template #input >
            <plate-number-input v-model="plateNumber" class="plate-text"></plate-number-input>
          </template>
        </van-field>
        <div class="plate-number-title" v-if="filteredPlateNumbers.length">您的车牌可能是:</div>
        <!--<div class="plate-number-title" v-else>输入车牌后,点击确定查询您的停车信息</div>-->
        <ul class="plate-number-list">
          <li class="plate-number-item" v-for="p in filteredPlateNumbers" :key="p"><a @click="plateNumber=p">{{p}}</a></li>
        </ul>
        <div style="margin: 16px;">
          <van-button round block type="primary" native-type="submit">确定</van-button>
        </div>
        <br />
      </van-form>
      <van-notice-bar  left-icon="info-o" mode="link" @click="scan">停放多层车库的车主,请扫描车架上的二维码</van-notice-bar>
      <br />
      <br />
      <br />
      <popularize spaceId="618822922264641536" class="popular"/>
  </div>
</template>

<script>
import { Form, Field, Button, CellGroup, NoticeBar, Dialog } from 'vant';
import qs from 'query-string';
import PlateNumberInputVue from '../components/PlateNumberInput.vue';
import { router } from '../router';
import store from '../components/store';
import PopularizeVue from '../components/Popularize.vue';
export default {
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [NoticeBar.name]: NoticeBar,
    'plate-number-input': PlateNumberInputVue,
    'popularize' : PopularizeVue
  },
  data() {
    return {
      parkId: null,
      parkingLotId: 0,
      plateNumber: '',
      plateNumberPattern : /.{7,8}/,
      possiblePlateNumbers: [],
      user: store.state.user
    };
  },
  mounted() {
    const { parkingLotId, parkId } = qs.parse(location.search);
    const that = this;
    const http = this.$http;
    http.get('/member/last_member_scan_order').then(last => {
      if (last && last.result) {
        router.push('/parking?orderId='+last.result);
      } else {
        if (parkingLotId || parkId) {
          this.parkingLotId = parkingLotId;
          this.parkId = parkId;
          http.get('/order/parking_plate_numbers', { parkingLotId, parkId }).then(list => that.possiblePlateNumbers = list);
        }
        http.get('/member/last_plate_number').then(p => that.plateNumber = p.result || '');
      }
    })
  },
  methods: {
   onSubmit: function(values) {
     const that = this;
     this.$http.get('/order/find_by_plate_number', {plateNumber : values.plateNumber, parkingLotId : this.parkingLotId, parkId: this.parkId}).then(function(result){
        const orderId = result.result;
        if (orderId){
            router.push('/paying?orderId='+orderId);
        }
        else {
          Dialog.alert({
            title: '找不到车牌',
            message: '您选择的车辆('+that.plateNumber+')未在停车中'
          })
        }
    });
   },
   scan(){
     router.push('/scan')
   }
  },
  computed: {
    filteredPlateNumbers() {
      const word = this.plateNumber;
      const list = this.possiblePlateNumbers.filter(x => x && (!word || x.startsWith(word))).slice(0, 4);
      if (list.length === 1 && list[0] === word) {
        return [];
      } else {
        return list;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  background-color: #eee;
  margin: 0;
}
.plate-form {
  background-color: white;
  padding: 15px 0
}
.cell-title {
  font-size: 0.9em;
  color: gray;
  padding: 16px 12px;
}
.plate-number-title {
  font-size: 0.8em;
  color: gray;
  margin: 10px;
}
.plate-number-list {
  list-style: none;
  color: gray;
  margin: 0 5px;
}
.plate-text {
  font-size: 18px;
}
.plate-number-item {
  list-style: none;
  display: inline;
  font-size: 1em;
  margin: 5px;
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}
.popular {
  position: fixed;
  bottom: 0;
}
</style>